// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PersonSearch24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PersonSearch24: FC<PersonSearch24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11 12c-1.1 0-2.042-.392-2.825-1.175C7.392 10.042 7 9.1 7 8s.392-2.042 1.175-2.825C8.958 4.392 9.9 4 11 4s2.042.392 2.825 1.175C14.608 5.958 15 6.9 15 8s-.392 2.042-1.175 2.825C13.042 11.608 12.1 12 11 12Zm0-2c.55 0 1.02-.196 1.412-.588C12.804 9.021 13 8.55 13 8c0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 11 6c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 9 8c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm11.1 13.5-3.2-3.2c-.35.2-.725.367-1.125.5s-.825.2-1.275.2c-1.25 0-2.313-.438-3.188-1.313C12.438 18.813 12 17.75 12 16.5c0-1.25.438-2.313 1.313-3.188C14.187 12.438 15.25 12 16.5 12c1.25 0 2.313.438 3.188 1.313C20.563 14.187 21 15.25 21 16.5c0 .45-.067.875-.2 1.275-.133.4-.3.775-.5 1.125l3.2 3.2-1.4 1.4ZM16.5 19c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C17.792 14.242 17.2 14 16.5 14s-1.292.242-1.775.725C14.242 15.208 14 15.8 14 16.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725ZM3 20v-2.775c0-.567.142-1.092.425-1.575.283-.483.675-.85 1.175-1.1.85-.433 1.808-.8 2.875-1.1 1.067-.3 2.25-.45 3.55-.45-.2.3-.37.62-.513.963a6.564 6.564 0 0 0-.337 1.062c-1 .083-1.892.254-2.675.512-.783.259-1.442.53-1.975.813a.905.905 0 0 0-.388.362c-.091.159-.137.33-.137.513V18h5.175c.083.367.196.717.337 1.05.142.333.313.65.513.95H3Z" />
        </svg>
    );
};

export default PersonSearch24;
